import React, { useEffect, useMemo, useState } from 'react';
import './AdminVendors.css';
import { apiClient, endpoints } from '../api';

const AdminKYCReview = () => {
  // vendor-specific document state removed
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ vendor: '', document_type: '', status: '', expiry_from: '', expiry_to: '' });
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  // vendor-specific review state removed
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // Vendor-specific state removed
  const [summary, setSummary] = useState(null);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditGlobal, setAuditGlobal] = useState([]);
  const [auditTotal, setAuditTotal] = useState(0);
  const [auditFilters, setAuditFilters] = useState({ vendor: '', action: '', admin: '' });
  const [auditPage, setAuditPage] = useState(1);
  // Vendor status update state removed
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDoc, setModalDoc] = useState(null);
  const [expected, setExpected] = useState({ name: '', pan: '' });
  const [buttonLoading, setButtonLoading] = useState({});
  
  // Sorting & bulk selection state
  const [sortBy, setSortBy] = useState('uploaded_at');
  const [sortDir, setSortDir] = useState('desc');
  const [selectedRows, setSelectedRows] = useState(new Set());

  const adminHeaders = { 'x-admin-key': (window.localStorage.getItem('ADMIN_API_KEY') || 'dev-admin-key') };

  // vendor-specific image display logic removed

  // loadVendors function removed

  // setVendorStatus function removed

  // loadDocs function removed (vendor-specific)

  const openPreviewModal = async (docId) => {
    try {
      // Find in current list instead of docs
      const doc = (list || []).find(d => String(d.id) === String(docId));
      setModalDoc(doc || null);
      setIsModalOpen(true);
    } catch (_) {
      setIsModalOpen(true);
    }
  };

  const closePreviewModal = () => {
    setIsModalOpen(false);
    setModalDoc(null);
  };

  const loadAll = async () => {
    try {
      setLoading(true);
      const params = { ...filters, page, limit };
      const { data } = await apiClient.get(endpoints.adminKycDocuments, { params, headers: adminHeaders });
      let items = data.items || [];
      // Client-side sorting (fallback if backend not providing order)
      items = [...items].sort((a, b) => {
        const dir = sortDir === 'asc' ? 1 : -1;
        const getVal = (row) => {
          if (sortBy === 'uploaded_at') return new Date(row.uploaded_at || 0).getTime();
          if (sortBy === 'expiry_date') return row.expiry_date ? new Date(row.expiry_date).getTime() : 0;
          if (sortBy === 'status') return String(row.doc_status || '');
          return new Date(row.uploaded_at || 0).getTime();
        };
        const va = getVal(a); const vb = getVal(b);
        if (va < vb) return -1 * dir;
        if (va > vb) return 1 * dir;
        return 0;
      });
      setList(items);
      setTotal(Number(data.total || 0));
      // Reset bulk selection on new data
      setSelectedRows(new Set());
    } catch (e) {
      setError('Failed to load KYC documents');
    } finally {
      setLoading(false);
    }
  };

  const loadSummary = async () => {
    try {
      const params = { vendor: filters.vendor, document_type: filters.document_type, status: filters.status, date_from: filters.submitted_from, date_to: filters.submitted_to };
      const { data } = await apiClient.get(endpoints.adminKycSummary, { params, headers: adminHeaders });
      setSummary(data);
    } catch (_) {}
  };

  // loadAudit function removed (vendor-specific)

  const loadAuditGlobal = async () => {
    try {
      setAuditLoading(true);
      const params = { ...auditFilters, page: auditPage, limit: 20 };
      const { data } = await apiClient.get(endpoints.adminKycAudit, { params, headers: adminHeaders });
      setAuditGlobal(data.items || []);
      setAuditTotal(Number(data.total || 0));
    } catch (e) {
      setError('Failed to load audit');
    } finally {
      setAuditLoading(false);
    }
  };

  const runOCR = async (docId) => {
    try {
      const loadingMsg = document.createElement('div');
      loadingMsg.innerHTML = 'OCR processing... This may take a few seconds.';
      loadingMsg.style.cssText = 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #fff; padding: 20px; border: 2px solid #3b82f6; border-radius: 8px; z-index: 10000; box-shadow: 0 4px 6px rgba(0,0,0,0.1);';
      document.body.appendChild(loadingMsg);

      const response = await apiClient.post(endpoints.adminDocOCR(docId), {}, { headers: adminHeaders });
      
      document.body.removeChild(loadingMsg);
      
      if (response.data?.text) {
        alert(`OCR completed successfully! Extracted text preview:\n\n${response.data.text.substring(0, 200)}${response.data.text.length > 200 ? '...' : ''}`);
      } else {
        alert('OCR completed successfully!');
      }
      
      await loadAll();
    } catch (e) {
      // Remove loading message if it exists
      const loadingMsg = document.querySelector('div[style*="OCR processing"]');
      if (loadingMsg) document.body.removeChild(loadingMsg);
      
      console.error('OCR Error:', e);
      const errorMsg = e.response?.data?.error || 'OCR processing failed. Please try again.';
      alert(`OCR Failed: ${errorMsg}`);
    }
  };

  const verifyDoc = async (docId) => {
    try {
      const payload = { expected };
      // Use alias route
      await apiClient.post(endpoints.adminDocVerify(docId), payload, { headers: adminHeaders });
      await loadAll();
    } catch (e) {
      alert('Verification failed');
    }
  };

  const deleteDoc = async (docId) => {
    try {
      const ok = window.confirm('Are you sure you want to delete this document? This action cannot be undone.');
      if (!ok) return;
      
      await apiClient.delete(endpoints.adminDocDelete(docId), { headers: adminHeaders });
      alert('Document deleted successfully!');
      await loadAll();
    } catch (e) {
      console.error('Delete error:', e);
      const errorMsg = e.response?.data?.error || 'Failed to delete document';
      alert('Delete failed: ' + errorMsg);
    }
  };

  // submitReview function removed (vendor-specific)

  const toggleRowSelected = (id) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleAllSelected = () => {
    setSelectedRows(prev => {
      if (prev.size === list.length) return new Set();
      return new Set(list.map(r => r.id));
    });
  };

  const bulkApprove = async () => {
    if (selectedRows.size === 0) return;
    const ok = window.confirm(`Approve ${selectedRows.size} document(s)?`);
    if (!ok) return;
    try {
      for (const id of selectedRows) {
        await apiClient.put(endpoints.adminKycDocumentStatus(id), { status: 'APPROVED' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk approve completed');
    } catch (_) {
      alert('Bulk approve failed (some items may be processed)');
    }
  };

  const bulkReject = async () => {
    if (selectedRows.size === 0) return;
    const reason = window.prompt(`Enter rejection reason for ${selectedRows.size} document(s):`, '');
    if (reason === null) return;
    try {
      for (const id of selectedRows) {
        await apiClient.post(endpoints.adminDocReject(id), { reason: reason || '' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk reject completed');
    } catch (_) {
      alert('Bulk reject failed (some items may be processed)');
    }
  };

  useEffect(() => { loadAuditGlobal(); }, [auditFilters.vendor, auditFilters.action, auditFilters.admin, auditPage]);
  useEffect(() => { loadAll(); loadSummary(); }, [filters.vendor, filters.document_type, filters.status, filters.expiry_from, filters.expiry_to, page]);

  return (
    <div className="admin-vendors">
      <div className="admin-vendors-header">
        <div className="admin-vendors-header-content">
          <h1>KYC Review</h1>
          <p>Review vendor documents with OCR highlights</p>
        </div>
      </div>

      {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}

      <div className="admin-vendors-filters" style={{ alignItems: 'center' }}>
        <div className="admin-filters-left">
          {/* Vendor selection removed */}
        </div>
        <div className="admin-filters-right" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {/* Vendor status controls removed */}
        </div>
      </div>

          {summary && (
            <>
            <div className="admin-vendors-header" style={{ marginTop: 8 }}>
              <div className="admin-vendors-header-content">
                <h2 style={{ margin: 0 }}>KYC Dashboard Overview</h2>
                <p style={{ margin: 0 }}>Snapshot of KYC progress across vendors</p>
              </div>
            </div>
            <div className="kyc-dashboard-grid">
              <div className="kyc-dashboard-card">
                <div className="kyc-card-icon">👥</div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Total Vendors</div>
                  <div className="kyc-card-value">{summary.totalVendors}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card">
                <div className="kyc-card-icon">📄</div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Documents Submitted</div>
                  <div className="kyc-card-value">{summary.totalDocuments}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-success">
                <div className="kyc-card-icon">✅</div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Verified Documents</div>
                  <div className="kyc-card-value">{summary.verifiedDocuments}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-warning">
                <div className="kyc-card-icon">⏳</div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Pending Verification</div>
                  <div className="kyc-card-value">{summary.pendingVerification}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-error">
                <div className="kyc-card-icon">❌</div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Rejected Documents</div>
                  <div className="kyc-card-value">{summary.rejectedDocuments}</div>
                </div>
              </div>
            </div>
            </>
          )}
          {summary && (
            <div className="kyc-expiring-alerts">
              <div className="kyc-alerts-header">
                <div className="kyc-alerts-icon">⚠️</div>
                <div className="kyc-alerts-title">Expiring Alerts (by retention)</div>
              </div>
              <div className="kyc-alerts-content">
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">30 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days30 || 0}</span>
                </div>
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">60 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days60 || 0}</span>
                </div>
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">90 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days90 || 0}</span>
                </div>
              </div>
            </div>
          )}
          <div className="admin-vendors-table-container">
          <div style={{ marginTop: 16 }}>
            <h3>All KYC Documents</h3>
          <div className="kyc-filters-section">
            <div className="kyc-filters-header">
              <h3>Filter & Search Documents</h3>
              <p>Use filters to find specific documents quickly</p>
            </div>
            
            <div className="kyc-filters-grid">
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Vendor Search</label>
                <input 
                  className="kyc-filter-input" 
                  placeholder="Search by vendor name or ID" 
                  value={filters.vendor} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, vendor: e.target.value }); }} 
                />
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Document Type</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.document_type} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, document_type: e.target.value }); }}
                >
                  <option value="">All Document Types</option>
                  <option value="gst">GST Certificate</option>
                  <option value="pan">PAN Card</option>
                  <option value="fssai">FSSAI License</option>
                  <option value="shopLicense">Shop License</option>
                  <option value="aadhaar">Aadhaar Card</option>
                  <option value="bankProof">Bank Proof</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Status</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.status} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, status: e.target.value }); }}
                >
                  <option value="">All Statuses</option>
                  <option value="UPLOADED">Uploaded</option>
                  <option value="OCR_CHECK">OCR Check</option>
                  <option value="FLAGGED">Flagged</option>
                  <option value="MANUAL_REVIEW">Manual Review</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECTED">Rejected</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Verification Status</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.verification_status || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, verification_status: e.target.value }); }}
                >
                  <option value="">All Verification Status</option>
                  <option value="PENDING">Pending</option>
                  <option value="VERIFIED">Verified</option>
                  <option value="REJECTED">Rejected</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Sort By</label>
                <select 
                  className="kyc-filter-select" 
                  value={sortBy} 
                  onChange={(e) => { setSortBy(e.target.value); }}
                >
                  <option value="uploaded_at">Submitted Date</option>
                  <option value="expiry_date">Expiry Date</option>
                  <option value="status">Status</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Sort Order</label>
                <select 
                  className="kyc-filter-select" 
                  value={sortDir} 
                  onChange={(e) => { setSortDir(e.target.value); }}
                >
                  <option value="desc">Newest First</option>
                  <option value="asc">Oldest First</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">From Date</label>
                <input 
                  type="date" 
                  className="kyc-filter-input" 
                  value={filters.submitted_from || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_from: e.target.value }); }} 
                />
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">To Date</label>
                <input 
                  type="date" 
                  className="kyc-filter-input" 
                  value={filters.submitted_to || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_to: e.target.value }); }} 
                />
              </div>
            </div>
          </div>
            <div className="kyc-bulk-actions">
              <div className="kyc-bulk-header">
                <h4>Bulk Actions</h4>
                <span className="kyc-selected-count">{selectedRows.size} document(s) selected</span>
              </div>
              <div className="kyc-bulk-buttons">
                <button className="kyc-bulk-btn kyc-bulk-select" onClick={toggleAllSelected}>
                  {selectedRows.size === list.length && list.length > 0 ? 'Unselect All' : 'Select All'}
                </button>
                <button className="kyc-bulk-btn kyc-bulk-approve" onClick={bulkApprove} disabled={selectedRows.size === 0}>
                  Bulk Approve
                </button>
                <button className="kyc-bulk-btn kyc-bulk-reject" onClick={bulkReject} disabled={selectedRows.size === 0}>
                  Bulk Reject
                </button>
              </div>
            </div>
            <div className="kyc-table-container">
              <table className="kyc-documents-table">
                <thead>
                  <tr>
                    <th className="kyc-col-checkbox"></th>
                    <th className="kyc-col-vendor">Vendor</th>
                    <th className="kyc-col-details">Vendor Details</th>
                    <th className="kyc-col-type">Document Type</th>
                    <th className="kyc-col-number">Document Number</th>
                    <th className="kyc-col-date">Submitted</th>
                    <th className="kyc-col-status">Status</th>
                    <th className="kyc-col-verified">Verified By</th>
                    <th className="kyc-col-expiry">Expiry Date</th>
                    <th className="kyc-col-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={10} className="kyc-loading">
                        <div className="kyc-loading-spinner">Loading documents...</div>
                      </td>
                    </tr>
                  )}
                  {!loading && list.map(row => (
                    <tr key={row.id} className="kyc-table-row" onClick={() => openPreviewModal(row.id)}>
                      <td className="kyc-col-checkbox" onClick={(e) => { e.stopPropagation(); toggleRowSelected(row.id); }}>
                        <input type="checkbox" checked={selectedRows.has(row.id)} onChange={() => {}} />
                      </td>
                      <td className="kyc-col-vendor">
                        <div className="kyc-vendor-info">
                          <div className="kyc-vendor-name">{row.vendor_name}</div>
                        </div>
                      </td>
                      <td className="kyc-col-details">
                        <div className="kyc-vendor-details">
                          <div className="kyc-vendor-id">#{row.vendor_id}</div>
                          <div className="kyc-vendor-name-small">{row.vendor_name}</div>
                        </div>
                      </td>
                      <td className="kyc-col-type">
                        <span className="kyc-doc-type">{row.document_type}</span>
                      </td>
                      <td className="kyc-col-number">
                        <span className="kyc-doc-number">{row.document_number || '-'}</span>
                      </td>
                      <td className="kyc-col-date">
                        <div className="kyc-date-info">
                          <div className="kyc-date">{new Date(row.uploaded_at).toLocaleDateString()}</div>
                          <div className="kyc-time">{new Date(row.uploaded_at).toLocaleTimeString()}</div>
                        </div>
                      </td>
                      <td className="kyc-col-status">
                        <span className={`kyc-status-badge kyc-status-${String(row.doc_status||'').toLowerCase()}`}>
                          {row.doc_status}
                        </span>
                      </td>
                      <td className="kyc-col-verified">
                        <span className="kyc-verified-by">{row.verified_by || '-'}</span>
                      </td>
                      <td className="kyc-col-expiry">
                        <span className="kyc-expiry-date">
                          {row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : '-'}
                        </span>
                      </td>
                      <td className="kyc-col-actions" onClick={(e) => e.stopPropagation()}>
                        <div className="kyc-action-buttons">
                          <button className="kyc-action-btn kyc-btn-approve" onClick={async (e) => { 
                            e.stopPropagation(); 
                            const ok = window.confirm('Approve this document? This will mark it as VERIFIED.'); 
                            if (!ok) return; 
                            try {
                              await apiClient.put(endpoints.adminKycDocumentStatus(row.id), { status: 'APPROVED' }, { headers: adminHeaders }); 
                              alert('Document approved successfully!');
                              loadAll(); 
                            } catch (error) {
                              console.error('Approval error:', error);
                              const errorMsg = error.response?.data?.error || 'Unknown error';
                              
                              // If it's a transition error, try the direct approve endpoint
                              if (errorMsg.includes('Invalid transition')) {
                                try {
                                  await apiClient.post(endpoints.adminDocApprove(row.id), { notes: 'Approved' }, { headers: adminHeaders });
                                  alert('Document approved successfully!');
                                  loadAll();
                                } catch (fallbackError) {
                                  console.error('Fallback approval error:', fallbackError);
                                  alert('Failed to approve document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                                }
                              } else {
                                alert('Failed to approve document: ' + errorMsg);
                              }
                            }
                          }}>Approve</button>
                          <button className="kyc-action-btn kyc-btn-reject" onClick={async (e) => { 
                            e.stopPropagation(); 
                            const reason = window.prompt('Enter rejection reason (optional):', ''); 
                            if (reason === null) return; // User cancelled
                            try {
                              await apiClient.post(endpoints.adminDocReject(row.id), { reason: reason || '' }, { headers: adminHeaders }); 
                              alert('Document rejected successfully!');
                              loadAll(); 
                            } catch (error) {
                              console.error('Rejection error:', error);
                              const errorMsg = error.response?.data?.error || 'Unknown error';
                              
                              // If it's a transition error, try the status update endpoint
                              if (errorMsg.includes('Invalid transition')) {
                                try {
                                  await apiClient.put(endpoints.adminKycDocumentStatus(row.id), { status: 'REJECTED', notes: reason || '' }, { headers: adminHeaders });
                                  alert('Document rejected successfully!');
                                  loadAll();
                                } catch (fallbackError) {
                                  console.error('Fallback rejection error:', fallbackError);
                                  alert('Failed to reject document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                                }
                              } else {
                                alert('Failed to reject document: ' + errorMsg);
                              }
                            }
                          }}>Reject</button>
                          <button className="kyc-action-btn kyc-btn-download" onClick={(e) => { 
                            e.stopPropagation(); 
                            (async () => { 
                              try { 
                                const response = await apiClient.get(endpoints.adminKycDownload(row.id), { headers: adminHeaders, responseType: 'blob' }); 
                                const url = window.URL.createObjectURL(new Blob([response.data])); 
                                const link = document.createElement('a'); 
                                link.href = url; 
                                link.setAttribute('download', row.original_name || `${row.document_type}-${row.id}`); 
                                document.body.appendChild(link); 
                                link.click(); 
                                link.remove(); 
                                window.URL.revokeObjectURL(url); // Clean up memory
                              } catch (error) { 
                                console.error('Download error:', error);
                                alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                              } 
                            })(); 
                          }}>Download</button>
                          <button className="kyc-action-btn kyc-btn-ocr" onClick={(e) => { e.stopPropagation(); runOCR(row.id); }}>OCR</button>
                          <button className="kyc-action-btn kyc-btn-delete" onClick={(e) => { e.stopPropagation(); deleteDoc(row.id); }}>Delete</button>
                          <button className="kyc-action-btn kyc-btn-verify" onClick={async (e) => { e.stopPropagation(); const ok = window.confirm('Confirm verification using the Expected Fields on the right panel?'); if (!ok) return; await verifyDoc(row.id); }}>Verify</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!loading && list.length === 0 && (
                    <tr>
                      <td colSpan={10} className="kyc-empty">
                        <div className="kyc-empty-state">
                          <div className="kyc-empty-icon">📄</div>
                          <div className="kyc-empty-text">No documents found</div>
                          <div className="kyc-empty-subtext">Try adjusting your filters to see more results</div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="kyc-pagination">
              <div className="kyc-pagination-info">
                <span className="kyc-total-count">Total: {total} documents</span>
                <span className="kyc-page-info">Page {page} of {Math.ceil(total / limit)}</span>
              </div>
              <div className="kyc-pagination-controls">
                <button 
                  className="kyc-pagination-btn" 
                  disabled={page <= 1} 
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                >
                  Previous
                </button>
                <span className="kyc-page-number">{page}</span>
                <button 
                  className="kyc-pagination-btn" 
                  disabled={(page * limit) >= total} 
                  onClick={() => setPage(p => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
            <div className="kyc-audit-section">
              <div className="kyc-audit-header">
                <h3>Global Audit Trail</h3>
                <p>Track all KYC document actions and changes</p>
              </div>
              
              <div className="kyc-audit-filters">
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Vendor Search</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="Search by vendor name or ID" 
                    value={auditFilters.vendor} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, vendor: e.target.value }); }} 
                  />
                </div>
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Action Type</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="approve/reject/ocr/verify/notify" 
                    value={auditFilters.action} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, action: e.target.value }); }} 
                  />
                </div>
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Admin ID</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="Admin identifier" 
                    value={auditFilters.admin} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, admin: e.target.value }); }} 
                  />
                </div>
              </div>
              
              <div className="kyc-audit-table-container">
                <table className="kyc-audit-table">
                  <thead>
                    <tr>
                      <th className="kyc-audit-col-time">Time</th>
                      <th className="kyc-audit-col-vendor">Vendor</th>
                      <th className="kyc-audit-col-doc">Document</th>
                      <th className="kyc-audit-col-action">Action</th>
                      <th className="kyc-audit-col-admin">Admin</th>
                      <th className="kyc-audit-col-notes">Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {auditLoading && (
                      <tr>
                        <td colSpan={6} className="kyc-audit-loading">
                          <div className="kyc-audit-loading-spinner">Loading audit trail...</div>
                        </td>
                      </tr>
                    )}
                    {!auditLoading && auditGlobal.map(r => (
                      <tr key={r.id} className="kyc-audit-row">
                        <td className="kyc-audit-col-time">
                          <div className="kyc-audit-time">
                            <div className="kyc-audit-date">{new Date(r.created_at).toLocaleDateString()}</div>
                            <div className="kyc-audit-time-small">{new Date(r.created_at).toLocaleTimeString()}</div>
                          </div>
                        </td>
                        <td className="kyc-audit-col-vendor">
                          <div className="kyc-audit-vendor">
                            <div className="kyc-audit-vendor-name">{r.vendor_name || r.vendor_id}</div>
                          </div>
                        </td>
                        <td className="kyc-audit-col-doc">
                          <div className="kyc-audit-doc">
                            <div className="kyc-audit-doc-type">{r.document_type || '-'}</div>
                            {r.original_name && (
                              <div className="kyc-audit-doc-name">({r.original_name})</div>
                            )}
                          </div>
                        </td>
                        <td className="kyc-audit-col-action">
                          <span className={`kyc-audit-action kyc-audit-action-${r.action?.toLowerCase()}`}>
                            {r.action}
                          </span>
                        </td>
                        <td className="kyc-audit-col-admin">
                          <span className="kyc-audit-admin">{r.admin_identifier || '-'}</span>
                        </td>
                        <td className="kyc-audit-col-notes">
                          <span className="kyc-audit-notes">{r.notes || ''}</span>
                        </td>
                      </tr>
                    ))}
                    {!auditLoading && auditGlobal.length === 0 && (
                      <tr>
                        <td colSpan={6} className="kyc-audit-empty">
                          <div className="kyc-audit-empty-state">
                            <div className="kyc-audit-empty-icon">📋</div>
                            <div className="kyc-audit-empty-text">No audit records found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
              <div className="kyc-audit-pagination">
                <div className="kyc-audit-pagination-info">
                  <span className="kyc-audit-total-count">Total: {auditTotal} records</span>
                  <span className="kyc-audit-page-info">Page {auditPage} of {Math.ceil(auditTotal / 20)}</span>
                </div>
                <div className="kyc-audit-pagination-controls">
                  <button 
                    className="kyc-audit-pagination-btn" 
                    disabled={auditPage <= 1} 
                    onClick={() => setAuditPage(p => Math.max(1, p - 1))}
                  >
                    Previous
                  </button>
                  <span className="kyc-audit-page-number">{auditPage}</span>
                  <button 
                    className="kyc-audit-pagination-btn" 
                    disabled={(auditPage * 20) >= auditTotal} 
                    onClick={() => setAuditPage(p => p + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>

      {isModalOpen && (
        <div className="kyc-modal-overlay" onClick={closePreviewModal}>
          <div className="kyc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="kyc-modal-header">
              <div className="kyc-modal-title">
                <h3>Document Preview & Review</h3>
                <p>Review document details and take action</p>
              </div>
              <button className="kyc-modal-close" onClick={closePreviewModal}>×</button>
            </div>
            
            <div className="kyc-modal-content">
              <div className="kyc-modal-preview">
                <div className="kyc-preview-container">
                  {(() => {
                    const d = modalDoc || selected;
                    if (!d) return <div className="kyc-no-document">No document selected</div>;
                    const mime = String(d.mime_type || '').toLowerCase();
                    const path = d.file_path ? `/${String(d.file_path).replace('\\','/')}` : '';
                    if (mime.startsWith('image/')) {
                      return (
                        <div className="kyc-image-container">
                          <img src={path} alt="Document Preview" className="kyc-document-image" />
                        </div>
                      );
                    }
                    return (
                      <div className="kyc-iframe-container">
                        <iframe title="Document Preview" src={path} className="kyc-document-iframe" />
                      </div>
                    );
                  })()}
                </div>
                
                <div className="kyc-preview-actions">
                  <button className="kyc-preview-btn kyc-btn-ocr" onClick={() => modalDoc && runOCR(modalDoc.id)}>
                    Run OCR
                  </button>
                  <button className="kyc-preview-btn kyc-btn-delete" onClick={() => modalDoc && deleteDoc(modalDoc.id)}>
                    Delete Document
                  </button>
                  <button className="kyc-preview-btn kyc-btn-download" onClick={async () => {
                    try {
                      if (!modalDoc) return;
                      const response = await apiClient.get(endpoints.adminKycDownload(modalDoc.id), { headers: adminHeaders, responseType: 'blob' });
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', modalDoc.original_name || `${modalDoc.original_name}-${modalDoc.id}`);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url);
                    } catch (error) { 
                      console.error('Download error:', error);
                      alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                    }
                  }}>
                    Download
                  </button>
                </div>
              </div>
              
              <div className="kyc-modal-details">
                <div className="kyc-document-info">
                  <div className="kyc-doc-header">
                    <h4>{modalDoc?.document_type?.toUpperCase()} Document</h4>
                    <span className="kyc-doc-id">#{modalDoc?.id}</span>
                  </div>
                  <div className="kyc-doc-meta">
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Submitted:</span>
                      <span className="kyc-meta-value">{new Date(modalDoc?.uploaded_at || Date.now()).toLocaleString()}</span>
                    </div>
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Status:</span>
                      <span className={`kyc-status-badge kyc-status-${String(modalDoc?.doc_status||'').toLowerCase()}`}>
                        {modalDoc?.doc_status || 'UPLOADED'}
                      </span>
                    </div>
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Verified By:</span>
                      <span className="kyc-meta-value">{modalDoc?.verified_by || '-'}</span>
                    </div>
                  </div>
                </div>
                
                <div className="kyc-expected-fields">
                  <h5>Expected Verification Fields</h5>
                  <div className="kyc-field-group">
                    <label className="kyc-field-label">Expected Name</label>
                    <input 
                      className="kyc-field-input" 
                      placeholder="Enter expected name" 
                      value={expected.name} 
                      onChange={e => setExpected({ ...expected, name: e.target.value })} 
                    />
                  </div>
                  <div className="kyc-field-group">
                    <label className="kyc-field-label">Expected Number</label>
                    <input 
                      className="kyc-field-input" 
                      placeholder="Enter expected number" 
                      value={expected.pan} 
                      onChange={e => setExpected({ ...expected, pan: e.target.value })} 
                    />
                  </div>
                </div>
                
                <div className="kyc-modal-actions">
                  <button className="kyc-action-btn kyc-btn-approve" onClick={async () => {
                    if (!modalDoc) return;
                    const ok = window.confirm('Approve this document?');
                    if (!ok) return;
                    try {
                      await apiClient.post(endpoints.adminDocApprove(modalDoc.id), { notes: 'Approved' }, { headers: adminHeaders });
                      alert('Document approved successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Approval error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      
                      // If it's a transition error, try the status update endpoint
                      if (errorMsg.includes('Invalid transition')) {
                        try {
                          await apiClient.put(endpoints.adminKycDocumentStatus(modalDoc.id), { status: 'APPROVED' }, { headers: adminHeaders });
                          alert('Document approved successfully!');
                          await loadAll();
                          closePreviewModal();
                        } catch (fallbackError) {
                          console.error('Fallback approval error:', fallbackError);
                          alert('Failed to approve document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                        }
                      } else {
                        alert('Failed to approve document: ' + errorMsg);
                      }
                    }
                  }}>
                    Approve Document
                  </button>
                  <button className="kyc-action-btn kyc-btn-reject" onClick={async () => {
                    if (!modalDoc) return;
                    const reason = window.prompt('Enter rejection reason (optional):', '');
                    if (reason === null) return; // User cancelled
                    try {
                      await apiClient.post(endpoints.adminDocReject(modalDoc.id), { reason: reason || '' }, { headers: adminHeaders });
                      alert('Document rejected successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Rejection error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      
                      // If it's a transition error, try the status update endpoint
                      if (errorMsg.includes('Invalid transition')) {
                        try {
                          await apiClient.put(endpoints.adminKycDocumentStatus(modalDoc.id), { status: 'REJECTED', notes: reason || '' }, { headers: adminHeaders });
                          alert('Document rejected successfully!');
                          await loadAll();
                          closePreviewModal();
                        } catch (fallbackError) {
                          console.error('Fallback rejection error:', fallbackError);
                          alert('Failed to reject document: ' + (fallbackError.response?.data?.error || 'Unknown error'));
                        }
                      } else {
                        alert('Failed to reject document: ' + errorMsg);
                      }
                    }
                  }}>
                    Reject Document
                  </button>
                  <button className="kyc-action-btn kyc-btn-verify" onClick={async () => {
                    if (!modalDoc) return;
                    const ok = window.confirm('Verify using expected fields?');
                    if (!ok) return;
                    await verifyDoc(modalDoc.id);
                    await loadAll();
                  }}>
                    Verify Document
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminKYCReview;


